import React from 'react'
import EditProfile from "./Profile";

export default function Profile() {
  return (
    <EditProfile />
  )
}
